<div class="container-plan">
  <div class="" style="display: flex; justify-content: space-between; width: 100%">
    <span class="title">Tipo de plan</span>
    <span style="display: flex; align-items: center; gap: 16px">
      <button
        class="btn-cancel btn-desktop"
        *ngIf="showCancelButton"
        [disabled]="user?.latest_active_subscription?.is_cancelled"
        (click)="cancelSubscription()"
        [ngClass]="{ 'disabled-button': user?.latest_active_subscription?.is_cancelled }"
      >
        Finalizar suscripción
      </button>

      <button
        *ngIf="
          planName !== 'FREE-UNLIMIT' && !user?.latest_active_subscription?.scheduled_downgrade
        "
        class="btn-plan btn-desktop"
        (click)="showPlansDialog = true"
      >
        {{ planName === 'FREE' ? 'Revisar planes' : 'Cambiar plan' }}
      </button>
    </span>
  </div>
  <div
    *ngIf="user?.latest_active_subscription?.scheduled_downgrade"
    style="
      margin-bottom: 12px;
      padding: 12px;
      background: var(--color-surface-100);
      border-radius: 8px;
      font-size: 14px;
    "
  >
    Cambiarás a
    <span style="font-weight: 700">{{
      user?.latest_active_subscription?.scheduled_downgrade?.new_plan_name || 'otro plan'
    }}</span>
    el
    <span style="font-weight: 700">{{
      user?.latest_active_subscription?.scheduled_downgrade?.effective_date | date : 'dd/MM/yyyy'
    }}</span
    >. Hasta entonces seguirás con Plan {{ planAlias }}.
    <button
      type="button"
      class="btn-plan"
      style="margin-top: 8px"
      (click)="revertScheduledDowngrade()"
    >
      Revertir cambio de plan
    </button>
  </div>
  <div style="font-size: 16px">
    Actualmente estás suscrito en
    <span style="font-weight: 700">Plan {{ planAlias || 'gratuito' }}. </span>
    <span *ngIf="planName !== 'FREE' && planName !== 'FREE-UNLIMIT'" style="font-size: 16px">
      <ng-container *ngIf="!user?.latest_active_subscription?.is_cancelled">
        Empezaste tu suscripción el día
        <span style="font-weight: 700; font-size: 16px">{{
          user?.latest_active_subscription?.start_date ||
            user?.latest_active_subscription?.created_at | date : 'dd/MM/yyyy'
        }}</span>
        y la fecha de renovación será el
        <span style="font-weight: 700"
          >{{ user?.latest_active_subscription?.end_date | date : 'dd/MM/yyyy' }}.</span
        >
      </ng-container>
      <ng-container *ngIf="user?.latest_active_subscription?.is_cancelled">
        Tu suscripción se cancelará al final del periodo. Tendrás acceso hasta el
        <span style="font-weight: 700">{{
          user?.latest_active_subscription?.end_date | date : 'dd/MM/yyyy'
        }}</span
        >. No se realizarán más cobros.
      </ng-container>
    </span>
  </div>

  <div style="width: 100%; height: 1px; background: var(--color-border)"></div>
  <span class="title">Uso</span>
  <div class="count">
    <div class="usage-messages">
      <div>
        Mensajes consumidos:
        <span style="font-weight: 700">{{ displayMessageConsumed }}/{{ displayMessageLimit }}</span>
        <span
          *ngIf="isNearCap"
          class="usage-badge usage-badge--warning"
          data-testid="near-cap-badge"
        >
          Cerca del límite
        </span>
        <span *ngIf="isAtCap" class="usage-badge usage-badge--danger" data-testid="at-cap-badge">
          Límite alcanzado
        </span>
      </div>
      <p-progressBar
        [value]="usagePercent"
        [showValue]="false"
        [styleClass]="'usage-progress-bar usage-progress-bar--' + usageSeverity"
        [style]="{ height: '8px' }"
        data-testid="usage-progress-bar"
      ></p-progressBar>
      <div *ngIf="cycleResetDate" class="usage-reset-date" data-testid="cycle-reset-date">
        Tu ciclo se reinicia el {{ cycleResetDate | date : 'dd/MM/yyyy' }}
      </div>
      <div *ngIf="isZeroUsage" class="usage-zero-state" data-testid="usage-zero-state">
        Aún no has consumido mensajes en este ciclo.
      </div>
    </div>
    <div>
      Asistentes:
      <span style="font-weight: 700">{{ displayChatbotsCount }}/{{ chatbotsLimit }}</span>
    </div>
    <div>
      Datasource:
      <span style="font-weight: 700">{{ displayDatasourcesCount }}/{{ sourcesLimit }}</span>
    </div>
  </div>

  <ng-container *ngIf="isViewingOwnWorkspace">
    <div style="width: 100%; height: 1px; background: var(--color-border)"></div>
    <span class="title">Consultas y leads por canal</span>

    <div
      *ngIf="isLoadingChannelUsage"
      class="channel-usage-loading"
      data-testid="channel-usage-loading"
    >
      Cargando...
    </div>

    <div
      *ngIf="!isLoadingChannelUsage && !hasChannelUsageData"
      class="channel-usage-zero-state"
      data-testid="channel-usage-zero-state"
    >
      Aún no hay consultas ni leads registrados en este ciclo.
    </div>

    <table
      *ngIf="!isLoadingChannelUsage && hasChannelUsageData"
      class="channel-usage-table"
      data-testid="channel-usage-table"
    >
      <caption class="visually-hidden">
        Uso por canal en el ciclo actual: consultas y leads registrados.
      </caption>
      <thead>
        <tr>
          <th>Canal</th>
          <th>Consultas</th>
          <th>Leads</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let entry of channelUsage"
          [attr.data-testid]="'channel-usage-row-' + entry.channel"
        >
          <td>{{ entry.label }}</td>
          <td>{{ entry.queries }}</td>
          <td>{{ entry.leads }}</td>
        </tr>
      </tbody>
    </table>
  </ng-container>
  <button
    class="btn-cancel btn-mobile"
    *ngIf="showCancelButton"
    [disabled]="user?.latest_active_subscription?.is_cancelled"
    (click)="cancelSubscription()"
    [ngClass]="{ 'disabled-button': user?.latest_active_subscription?.is_cancelled }"
  >
    Finalizar suscripción
  </button>
  <button
    *ngIf="planName !== 'FREE-UNLIMIT' && !user?.latest_active_subscription?.scheduled_downgrade"
    class="btn-mobile btn-plan"
    (click)="showPlansDialog = true"
  >
    Revisar planes
  </button>
</div>
<p-confirmDialog #cd data-dialog-type="end-subscription">
  <ng-template pTemplate="header">
    <h1>{{ confirmDialogHeader }}</h1>
  </ng-template>
  <ng-template pTemplate="footer">
    <button
      pButton
      pRipple
      type="button"
      [label]="confirmDialogRejectLabel"
      class="p-button-text"
      (click)="cd.reject()"
    ></button>
    <button
      type="button"
      pButton
      [label]="confirmDialogAcceptLabel"
      class="p-button-primary"
      (click)="cd.accept()"
    ></button>
  </ng-template>
</p-confirmDialog>
<p-dialog
  header="Planes de suscripción"
  [modal]="true"
  [style]="{ width: '70rem', maxWidth: '100%' }"
  [(visible)]="showPlansDialog"
  [breakpoints]="{ '1199px': '90vw', '900px': '95vw', '575px': '95vw' }"
  [resizable]="false"
  [draggable]="false"
  [contentStyle]="{ overflow: 'auto' }"
>
  <globot-type-subscription-plans
    [currentPlanAlias]="planAlias"
    [allowDowngrade]="
      !user?.latest_active_subscription?.is_cancelled &&
      !user?.latest_active_subscription?.scheduled_downgrade
    "
    [hasActivePaidPeriod]="hasActivePaidPeriod"
    [hasPaymentMethod]="hasPaymentMethod"
    (upgradeClick)="onUpgradeClick($event)"
    (downgradeClick)="onDowngradeClick($event)"
    (reactivateClick)="onReactivateClick($event)"
  ></globot-type-subscription-plans>
</p-dialog>
